<template>
  <div class="container-fluid" @save="saveDocument" style="height: 100vh;width:100%">
    <div class="btn-toolbar d-flex justify-content-between mt-2 mb-2">
      <button @click="saveDocument" class="btn btn-primary">Speichern</button>
      <button @click="openDocList" class="btn btn-secondary">Zurück</button>
      <div class="input-group">
        <div class="input-group-prepend">
          <label class="input-group-text">Name</label>
        </div>
        <input type="text" class="form-control" v-model="document.title"/>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <label class="input-group-text">Beschreibung</label>
        </div>
        <input type="text" class="form-control" v-model="document.label"/>
      </div>
    </div>
    <hr/>
    <div class="wrapper" style="height: 100vh; width: 100%;padding:10px;">
        <PageBuilder ref="editor" :mode="'jsonmail'"/>
    </div>
  </div>
</template>

<script>
import PageBuilder from '@/components/digitalfirm/cms/PageBuilder.vue'
import cmsdocs from '@/modules/cmsdocs.js'
import router from '@/router'

export default {
  components: {
    PageBuilder,
  },
  data() {
    return {
      cmsID: 0,
      catID: 0,
      label: '',
      document: {
        label: '',
      }
    }
  },
  created() {
    if (this.$route.params.docid && this.$route.params.docid !== 0) {
      this.cmsID = this.$route.params.docid;
    }
    this.tree = this.$route.params.tree;
    this.catID = this.$route.params.catid;
  },
  mounted() {
    var self = this;
    this.$refs.editor.createEditor(this.tree).then(function() {
      if (self.cmsID && self.cmsID > 0) {
        console.log('load page cms',self.cmsID);
        self.loadDocument();
      } else {
        console.log('create empty page');
        // init empty document meta data
        self.document.id = 0;
        self.document.title = '';
        self.document.catID = self.catID; // given cat id
        self.document.docType = 0; // default cms document
        self.document.docLink = 0;
        self.document.docTree = 'jsonmail';
        self.document.label = '';
        self.document.locale = 'de';
        self.document.fallback = false;
        self.document.export = false;
        self.document.styles = '';
        self.document.script = '';
      }
    });

  },
  methods: {

    extractTemplateCommands(html) {
      var output = '';
      var idx = -1;
      var input = html;

      // iterate while templatecommands given
      while ((idx = input.indexOf('outer="')) > 0) {
          // create debug msg
          var msg = input.substring(Math.min(idx-5),Math.max(idx+5,input.length));

          // debug
          console.log('found rem command',idx,msg);

          // check end of outer attribute
          var out2 = input.indexOf('"',idx+7);
          // error if not found
          if (out2 == -1) {
            console.error('Failed to parse outer attribute:',idx,msg);
            return html;
          }
          var oname = input.substring(idx+7,out2);
          console.log('oname',oname);

          // start offset suchen
          var start = input.substring(0,idx).lastIndexOf('<' + oname);
          if (start == -1) {
            console.error('Failed to parse start position:',idx,oname,msg);
            return html;
          }

          // end position prüfen
          var end = input.indexOf('</' + oname + '>',idx+7);
          if (start == -1) {
            console.error('Failed to parse start position:',idx,oname,msg);
            return html;
          }

          var cut = input.substring(start,end + oname.length + 3);
          console.log('cut:' + cut);
          console.log('append',input.substring(0,start));
          output += input.substring(0,start);
          input   = input.substring(end + oname.length + 3);
          console.log('rest:',input);

          // extract velocity part
          console.log('test',idx-start,cut.substring(idx-start));
          var cstart = cut.substring(idx-start).indexOf('>') + (idx - start) + 1;
          var cend   = cut.substring(idx-start).indexOf('<') + (idx - start);
          console.log('commands:',cut.substring(cstart),cstart,cend);
          if (cstart < 0 || cend < 0) {
            console.error('Failed to get commands: ',idx,start,end,msg);
            return html;
          } else {
            var cmd = cut.substring(cstart,cend);
            console.log('command:',cmd);
            output += cmd;
          }

      }
      output += input;

      console.log('outer html:',output);

      return output;
    },

    //
    // save document
    //
    saveDocument() {
      console.log('save cms doc');
      if (this.document.title == '') {
        this.$bvToast.toast('Bitte erst einen Namen vergeben!',{variant:'danger', title:'Dokument'});
        return;
      }
      var data = this.$refs.editor.getContent();

      console.log('save pre',this.$refs.editor.getCss(),this.$refs.editor.getHtml(),this.$refs.editor.getJs());
      this.document.styles = this.$refs.editor.getCss();
      this.document.script = this.$refs.editor.getJs();
      this.document.document = this.extractTemplateCommands(this.$refs.editor.getInlineCSSHTML());
      this.document.docTree  = 'jsonmail';

      console.log('inlined:',this.document.document);

//      console.log('css inline:',juice('<style>' + this.document.styles + '</style>' + this.document.document));

      console.log(data);
      this.document.documentData = JSON.stringify(data);
      var self = this;
      cmsdocs.saveDocument(this.document).then(function(doc) {
        self.document = doc;
        self.$bvToast.toast('Dokument gesichert',{variant: 'success', title:'Dokument'});
      });
    },

    openDocList() {
      router.push({name: 'CMSMailManager'});
    },

    //
    // load an cms document
    //
    async loadDocument() {
      var data = await cmsdocs.loadDocument(this.cmsID);
      console.log('load document:',data);
      this.document = data;
      this.$refs.editor.setContent(data);
    },

  }
}
</script>
